var map = {
	"./sux-abredeversicherung-48px.icon": [
		8445,
		8445
	],
	"./sux-abschluss-diplom-48px.icon": [
		9841,
		9841
	],
	"./sux-absenzenmanagement-48px.icon": [
		1702,
		1702
	],
	"./sux-accident-48px.icon": [
		4648,
		4648
	],
	"./sux-administration-48px.icon": [
		1929,
		1929
	],
	"./sux-agency-48px.icon": [
		8038,
		8038
	],
	"./sux-aktivitaeten-48px.icon": [
		8790,
		8790
	],
	"./sux-andere-48px.icon": [
		2656,
		2656
	],
	"./sux-anfrage-senden-48px.icon": [
		1995,
		1995
	],
	"./sux-arbeitsmedizinische-vorsorge-48px.icon": [
		669,
		669
	],
	"./sux-arbeitsweg-48px.icon": [
		6144,
		6144
	],
	"./sux-arbeitszeit-modell-desk-48px.icon": [
		2291,
		2291
	],
	"./sux-arrow-down-16px.icon": [
		7740,
		7740
	],
	"./sux-arrow-down-24px.icon": [
		1809,
		1809
	],
	"./sux-arrow-left-16px.icon": [
		5459,
		5459
	],
	"./sux-arrow-left-24px.icon": [
		3450,
		3450
	],
	"./sux-arrow-right-16px.icon": [
		9572,
		9572
	],
	"./sux-arrow-right-24px.icon": [
		8217,
		8217
	],
	"./sux-arrow-up-16px.icon": [
		8939,
		8939
	],
	"./sux-arrow-up-24px.icon": [
		7778,
		7778
	],
	"./sux-assistance-48px.icon": [
		1035,
		1035
	],
	"./sux-attachment-16px.icon": [
		6127,
		6127
	],
	"./sux-attachment-24px.icon": [
		7462,
		7462
	],
	"./sux-attention-48px.icon": [
		7123,
		7123
	],
	"./sux-aus-und-weiterbildung-books-read-48px.icon": [
		2154,
		2154
	],
	"./sux-aus-und-weiterbildung-koerper-geist-essen-salad-48px.icon": [
		1357,
		1357
	],
	"./sux-aus-und-weiterbildung-koerper-geist-yingyan-48px.icon": [
		5294,
		5294
	],
	"./sux-ausbildungsdauer-48px.icon": [
		5071,
		5071
	],
	"./sux-bagatellunfall-48px.icon": [
		1639,
		1639
	],
	"./sux-bau-48px.icon": [
		821,
		821
	],
	"./sux-belohnung-geschenk-present-48px.icon": [
		3508,
		3508
	],
	"./sux-benutzerverwaltung-48px.icon": [
		6297,
		6297
	],
	"./sux-berufskrankheit-48px.icon": [
		7001,
		7001
	],
	"./sux-berufsunfall-48px.icon": [
		7520,
		7520
	],
	"./sux-betriebsbeschreibung-48px.icon": [
		274,
		274
	],
	"./sux-betriebsbeschreibung-chf-48px.icon": [
		8512,
		8512
	],
	"./sux-betriebsbeschreibung-prozente-48px.icon": [
		5746,
		5746
	],
	"./sux-betriebsinformation-48px.icon": [
		9825,
		9825
	],
	"./sux-betriebsrevision-48px.icon": [
		2646,
		2646
	],
	"./sux-bonitaetsauskunft-48px.icon": [
		1285,
		1285
	],
	"./sux-bueroberufe-48px.icon": [
		4307,
		4307
	],
	"./sux-burger-16px.icon": [
		8407,
		8407
	],
	"./sux-burger-24px.icon": [
		8254,
		8254
	],
	"./sux-calendar-16px.icon": [
		5382,
		5382
	],
	"./sux-calendar-24px.icon": [
		2699,
		2699
	],
	"./sux-cart-16px.icon": [
		5638,
		5638
	],
	"./sux-cart-24px.icon": [
		187,
		187
	],
	"./sux-chat-16px.icon": [
		4338,
		4338
	],
	"./sux-chat-24px.icon": [
		8663,
		8663
	],
	"./sux-chat-48px.icon": [
		8245,
		8245
	],
	"./sux-check-mark-16px.icon": [
		470,
		470
	],
	"./sux-check-mark-24px.icon": [
		8635,
		8635
	],
	"./sux-checkliste-48px.icon": [
		2882,
		2882
	],
	"./sux-chemie-48px.icon": [
		4218,
		4218
	],
	"./sux-chevron-down-16px.icon": [
		7338,
		7338
	],
	"./sux-chevron-down-24px.icon": [
		3951,
		3951
	],
	"./sux-chevron-left-16px.icon": [
		2793,
		2793
	],
	"./sux-chevron-left-24px.icon": [
		968,
		968
	],
	"./sux-chevron-right-16px.icon": [
		3162,
		3162
	],
	"./sux-chevron-right-24px.icon": [
		9791,
		9791
	],
	"./sux-chevron-up-16px.icon": [
		3997,
		3997
	],
	"./sux-chevron-up-24px.icon": [
		6076,
		6076
	],
	"./sux-circle-arrow-down-16px.icon": [
		7267,
		7267
	],
	"./sux-circle-arrow-down-24px.icon": [
		7578,
		7578
	],
	"./sux-circle-arrow-left-16px.icon": [
		2396,
		2396
	],
	"./sux-circle-arrow-left-24px.icon": [
		2161,
		2161
	],
	"./sux-circle-arrow-right-16px.icon": [
		2797,
		2797
	],
	"./sux-circle-arrow-right-24px.icon": [
		5388,
		3007
	],
	"./sux-circle-arrow-up-16px.icon": [
		2440,
		59
	],
	"./sux-circle-arrow-up-24px.icon": [
		9805,
		9805
	],
	"./sux-circle-chevron-down-16px.icon": [
		3457,
		3457
	],
	"./sux-circle-chevron-down-24px.icon": [
		7184,
		7184
	],
	"./sux-circle-chevron-left-16px.icon": [
		242,
		242
	],
	"./sux-circle-chevron-left-24px.icon": [
		5079,
		5079
	],
	"./sux-circle-chevron-right-16px.icon": [
		4651,
		4651
	],
	"./sux-circle-chevron-right-24px.icon": [
		7490,
		7490
	],
	"./sux-circle-chevron-up-16px.icon": [
		8202,
		8202
	],
	"./sux-circle-chevron-up-24px.icon": [
		4815,
		4815
	],
	"./sux-class-type-48px.icon": [
		570,
		570
	],
	"./sux-clock-16px.icon": [
		2075,
		4456
	],
	"./sux-clock-24px.icon": [
		2749,
		2749
	],
	"./sux-close-16px.icon": [
		2186,
		2186
	],
	"./sux-close-24px.icon": [
		8591,
		8591
	],
	"./sux-copy-16px.icon": [
		6059,
		6059
	],
	"./sux-copy-24px.icon": [
		8658,
		8658
	],
	"./sux-costs-48px.icon": [
		3803,
		3803
	],
	"./sux-counter-16px.icon": [
		5690,
		5690
	],
	"./sux-counter-24px.icon": [
		8447,
		8447
	],
	"./sux-customer-portal-16px.icon": [
		3317,
		3317
	],
	"./sux-customer-portal-24px.icon": [
		1300,
		1300
	],
	"./sux-default-eservices-48px.icon": [
		992,
		992
	],
	"./sux-document-16px.icon": [
		219,
		219
	],
	"./sux-document-24px.icon": [
		1026,
		1026
	],
	"./sux-dokument-hochladen-48px.icon": [
		4627,
		4627
	],
	"./sux-dokumentenservice-48px.icon": [
		9270,
		9270
	],
	"./sux-download-16px.icon": [
		5076,
		5076
	],
	"./sux-download-24px.icon": [
		4265,
		4265
	],
	"./sux-drag-and-drop-16px.icon": [
		2078,
		2078
	],
	"./sux-drag-and-drop-24px.icon": [
		2451,
		2451
	],
	"./sux-du-kultur-48px.icon": [
		1042,
		1042
	],
	"./sux-duration-48px.icon": [
		4855,
		4855
	],
	"./sux-ebill-16px.icon": [
		1976,
		1976
	],
	"./sux-ebill-24px.icon": [
		7469,
		7469
	],
	"./sux-edit-16px.icon": [
		8380,
		8380
	],
	"./sux-edit-24px.icon": [
		1009,
		1009
	],
	"./sux-edit-48px.icon": [
		2635,
		2635
	],
	"./sux-elektrizitaet-48px.icon": [
		3330,
		3330
	],
	"./sux-email-16px.icon": [
		1582,
		1582
	],
	"./sux-email-24px.icon": [
		915,
		915
	],
	"./sux-email-48px.icon": [
		673,
		673
	],
	"./sux-entlohnung-money-coins-48px.icon": [
		615,
		615
	],
	"./sux-error-16px.icon": [
		1084,
		1084
	],
	"./sux-error-24px.icon": [
		4737,
		4737
	],
	"./sux-errormark-16px.icon": [
		6523,
		6523
	],
	"./sux-errormark-24px.icon": [
		9509,
		1890
	],
	"./sux-excel-16px.icon": [
		247,
		247
	],
	"./sux-excel-24px.icon": [
		8414,
		8414
	],
	"./sux-exit-16px.icon": [
		7504,
		7504
	],
	"./sux-exit-24px.icon": [
		389,
		389
	],
	"./sux-eye-16px.icon": [
		85,
		85
	],
	"./sux-eye-24px.icon": [
		2228,
		2228
	],
	"./sux-eye-slash-16px.icon": [
		5077,
		5077
	],
	"./sux-eye-slash-24px.icon": [
		6148,
		6148
	],
	"./sux-facebook-16px.icon": [
		5900,
		5900
	],
	"./sux-facebook-24px.icon": [
		9249,
		9249
	],
	"./sux-falldatenauswertung-48px.icon": [
		3587,
		3587
	],
	"./sux-familie-48px.icon": [
		1304,
		1304
	],
	"./sux-familie-beruf-48px.icon": [
		5053,
		5053
	],
	"./sux-familiezulagen-48px.icon": [
		1144,
		1144
	],
	"./sux-favorite-16px.icon": [
		6936,
		6936
	],
	"./sux-favorite-24px.icon": [
		9357,
		9357
	],
	"./sux-favorite-48px.icon": [
		6583,
		6583
	],
	"./sux-favorite-full-16px.icon": [
		5216,
		5216
	],
	"./sux-favorite-full-24px.icon": [
		8613,
		8613
	],
	"./sux-favorite-full-48px.icon": [
		9439,
		9439
	],
	"./sux-favorite-outline-48px.icon": [
		1050,
		1050
	],
	"./sux-feiertagsausgleich-48px.icon": [
		5454,
		5454
	],
	"./sux-filter-16px.icon": [
		7262,
		7262
	],
	"./sux-filter-24px.icon": [
		3987,
		3987
	],
	"./sux-folder-16px.icon": [
		6568,
		4187
	],
	"./sux-folder-24px.icon": [
		5213,
		5213
	],
	"./sux-folder-full-16px.icon": [
		3664,
		3664
	],
	"./sux-folder-full-24px.icon": [
		2085,
		2085
	],
	"./sux-fullview-16px.icon": [
		2880,
		2880
	],
	"./sux-fullview-24px.icon": [
		7893,
		7893
	],
	"./sux-fussball-cool-48px.icon": [
		5993,
		5993
	],
	"./sux-fussball-entscheid-48px.icon": [
		6173,
		6173
	],
	"./sux-fussball-positiv-48px.icon": [
		3842,
		3842
	],
	"./sux-fussball-verantwortungsvoll-48px.icon": [
		1058,
		1058
	],
	"./sux-fussball-vorbildlich-48px.icon": [
		9128,
		9128
	],
	"./sux-geburtstag-cake-kuchen-48px.icon": [
		445,
		445
	],
	"./sux-gefahren-meldung-48px.icon": [
		7014,
		7014
	],
	"./sux-gehoeruntersuchung-48px.icon": [
		2448,
		2448
	],
	"./sux-general-notification-16px.icon": [
		4044,
		4044
	],
	"./sux-general-notification-24px.icon": [
		4305,
		4305
	],
	"./sux-gewerbe-industrie-48px.icon": [
		3007,
		5388
	],
	"./sux-graphic-16px.icon": [
		6178,
		6178
	],
	"./sux-graphic-24px.icon": [
		2631,
		2631
	],
	"./sux-group-size-48px.icon": [
		5414,
		5414
	],
	"./sux-halbtax-abo-48px.icon": [
		3840,
		3840
	],
	"./sux-help-16px.icon": [
		6309,
		6309
	],
	"./sux-help-24px.icon": [
		8452,
		8452
	],
	"./sux-hilfe-kontakt-16px.icon": [
		4421,
		4421
	],
	"./sux-hilfe-kontakt-24px.icon": [
		5492,
		5492
	],
	"./sux-hilfe-kontakt-48px.icon": [
		6190,
		6190
	],
	"./sux-hoerschaden-48px.icon": [
		5819,
		5819
	],
	"./sux-home-16px.icon": [
		2649,
		2649
	],
	"./sux-home-24px.icon": [
		5192,
		5192
	],
	"./sux-home-48px.icon": [
		4418,
		4418
	],
	"./sux-image-16px.icon": [
		1557,
		1557
	],
	"./sux-image-24px.icon": [
		3188,
		3188
	],
	"./sux-image-48px.icon": [
		6206,
		3825
	],
	"./sux-info-16px.icon": [
		9136,
		9136
	],
	"./sux-info-24px.icon": [
		7557,
		7557
	],
	"./sux-instagram-16px.icon": [
		530,
		530
	],
	"./sux-instagram-24px.icon": [
		9911,
		9911
	],
	"./sux-jobs-48px.icon": [
		887,
		887
	],
	"./sux-kennzahlenuebersicht-48px.icon": [
		2817,
		2817
	],
	"./sux-kontaktformular-48px.icon": [
		9581,
		9581
	],
	"./sux-kontoauszug-48px.icon": [
		5563,
		5563
	],
	"./sux-korrespondenz-48px.icon": [
		8137,
		8137
	],
	"./sux-krankenversicherung-48px.icon": [
		6840,
		6840
	],
	"./sux-krankontrolle-48px.icon": [
		9637,
		9637
	],
	"./sux-kundenportal-48px.icon": [
		1314,
		1314
	],
	"./sux-langzeitkonto-48px.icon": [
		5938,
		5938
	],
	"./sux-link-external-16px.icon": [
		4114,
		4114
	],
	"./sux-link-external-24px.icon": [
		5287,
		5287
	],
	"./sux-linkedin-16px.icon": [
		2310,
		2310
	],
	"./sux-linkedin-24px.icon": [
		475,
		475
	],
	"./sux-location-16px.icon": [
		4529,
		4529
	],
	"./sux-location-24px.icon": [
		5792,
		5792
	],
	"./sux-logo-24px.icon": [
		2468,
		2468
	],
	"./sux-lohndeklaration-48px.icon": [
		5018,
		5018
	],
	"./sux-lohnfortzahlung-bei-krankheit-48px.icon": [
		5017,
		5017
	],
	"./sux-lwr-passgenau-24px.icon": [
		2250,
		2250
	],
	"./sux-lwr-passgenau-48px.icon": [
		2576,
		2576
	],
	"./sux-massnahmen-monitor-48px.icon": [
		3498,
		1117
	],
	"./sux-meine-kurse-48px.icon": [
		6784,
		6784
	],
	"./sux-meinschaden-48px.icon": [
		5032,
		5032
	],
	"./sux-meldeprozess-asbestsanierung-48px.icon": [
		4033,
		4033
	],
	"./sux-menu-table-raw-16px.icon": [
		1815,
		1815
	],
	"./sux-menu-table-raw-24px.icon": [
		3825,
		6206
	],
	"./sux-minus-16px.icon": [
		438,
		438
	],
	"./sux-minus-24px.icon": [
		4235,
		4235
	],
	"./sux-missing-icon-24px.icon": [
		5031,
		5031
	],
	"./sux-mitarbeiterschaden-48px.icon": [
		7185,
		7185
	],
	"./sux-mobileabo-smartphone-48px.icon": [
		8197,
		8197
	],
	"./sux-neuer-betrieb-hinzufuegen-48px.icon": [
		1543,
		1543
	],
	"./sux-nichtberufsunfall-48px.icon": [
		2792,
		2792
	],
	"./sux-ordentlicherunfall-48px.icon": [
		1476,
		1476
	],
	"./sux-pagination-left-16px.icon": [
		9960,
		9960
	],
	"./sux-pagination-left-24px.icon": [
		2253,
		2253
	],
	"./sux-pagination-right-16px.icon": [
		1553,
		1553
	],
	"./sux-pagination-right-24px.icon": [
		2816,
		2816
	],
	"./sux-paragraph-16px.icon": [
		2148,
		2148
	],
	"./sux-pdf-16px.icon": [
		5040,
		5040
	],
	"./sux-pdf-24px.icon": [
		4277,
		4277
	],
	"./sux-pensionskasse-48px.icon": [
		1105,
		1105
	],
	"./sux-personalverleih-48px.icon": [
		6184,
		6184
	],
	"./sux-perspektive-fernglas-48px.icon": [
		3610,
		3610
	],
	"./sux-pflege-48px.icon": [
		3044,
		3044
	],
	"./sux-phone-16px.icon": [
		102,
		102
	],
	"./sux-phone-24px.icon": [
		3899,
		3899
	],
	"./sux-phone-48px.icon": [
		2217,
		2217
	],
	"./sux-place-16px.icon": [
		3891,
		3891
	],
	"./sux-place-24px.icon": [
		4874,
		4874
	],
	"./sux-plus-16px.icon": [
		3856,
		3856
	],
	"./sux-plus-24px.icon": [
		7253,
		7253
	],
	"./sux-post-16px.icon": [
		2878,
		2878
	],
	"./sux-post-24px.icon": [
		5891,
		5891
	],
	"./sux-powerpoint-16px.icon": [
		4767,
		4767
	],
	"./sux-powerpoint-24px.icon": [
		6054,
		6054
	],
	"./sux-praemiendasboard-48px.icon": [
		9892,
		9892
	],
	"./sux-praemiendashboard-48px.icon": [
		9196,
		9196
	],
	"./sux-praeventionsprogramm-48px.icon": [
		1162,
		1162
	],
	"./sux-preparation-48px.icon": [
		9662,
		9662
	],
	"./sux-print-16px.icon": [
		9999,
		9999
	],
	"./sux-print-24px.icon": [
		1334,
		1334
	],
	"./sux-profil-48px.icon": [
		7465,
		7465
	],
	"./sux-profilverwaltung-48px.icon": [
		5012,
		5012
	],
	"./sux-quiz-48px.icon": [
		3608,
		3608
	],
	"./sux-refresh-16px.icon": [
		4875,
		4875
	],
	"./sux-refresh-24px.icon": [
		3938,
		3938
	],
	"./sux-registration-48px.icon": [
		6700,
		6700
	],
	"./sux-reisekoffer-48px.icon": [
		4150,
		4150
	],
	"./sux-reisen-flugzeug-48px.icon": [
		5347,
		5347
	],
	"./sux-rueckfall-48px.icon": [
		3708,
		3708
	],
	"./sux-safety-app-48px.icon": [
		3487,
		3487
	],
	"./sux-schaden-melden-48px.icon": [
		8729,
		8729
	],
	"./sux-schuelbuecher-books-read-48px.icon": [
		5529,
		5529
	],
	"./sux-scroll-top-circle-16px.icon": [
		1284,
		1284
	],
	"./sux-scroll-top-circle-24px.icon": [
		473,
		473
	],
	"./sux-search-16px.icon": [
		5812,
		5812
	],
	"./sux-search-24px.icon": [
		3881,
		3881
	],
	"./sux-secure-16px.icon": [
		6247,
		6247
	],
	"./sux-secure-24px.icon": [
		9918,
		9918
	],
	"./sux-secure-mail-48px.icon": [
		5428,
		5428
	],
	"./sux-selbstkontrolle-48px.icon": [
		6506,
		6506
	],
	"./sux-send-24px.icon": [
		8571,
		8571
	],
	"./sux-seperator-48px.icon": [
		3180,
		3180
	],
	"./sux-settings-16px.icon": [
		9695,
		9695
	],
	"./sux-settings-24px.icon": [
		9574,
		9574
	],
	"./sux-share-16px.icon": [
		6287,
		6287
	],
	"./sux-share-24px.icon": [
		7318,
		7318
	],
	"./sux-sicherheitspaesse-48px.icon": [
		1257,
		1257
	],
	"./sux-sicherheitspass-48px.icon": [
		4083,
		4083
	],
	"./sux-sizegrabber-16px.icon": [
		618,
		618
	],
	"./sux-sizegrabber-24px.icon": [
		3599,
		3599
	],
	"./sux-sms-code-48px.icon": [
		1416,
		1416
	],
	"./sux-sort-asc-16px.icon": [
		6160,
		6160
	],
	"./sux-sort-asc-24px.icon": [
		1173,
		1173
	],
	"./sux-sort-desc-16px.icon": [
		4080,
		4080
	],
	"./sux-sort-desc-24px.icon": [
		517,
		517
	],
	"./sux-sprachaufenthalt-plane-48px.icon": [
		3743,
		3743
	],
	"./sux-subnummer-16px.icon": [
		59,
		2440
	],
	"./sux-subnummer-24px.icon": [
		733,
		733
	],
	"./sux-success-16px.icon": [
		6471,
		6471
	],
	"./sux-success-24px.icon": [
		4622,
		4622
	],
	"./sux-support-agent-16px.icon": [
		6203,
		6203
	],
	"./sux-support-agent-24px.icon": [
		2450,
		2450
	],
	"./sux-support-agent-48px.icon": [
		5576,
		5576
	],
	"./sux-suva-nachhaltig-48px.icon": [
		6606,
		6606
	],
	"./sux-switch-arrows-16px.icon": [
		4381,
		4381
	],
	"./sux-switch-arrows-24px.icon": [
		8508,
		8508
	],
	"./sux-table-16px.icon": [
		1654,
		1654
	],
	"./sux-table-24px.icon": [
		8971,
		8971
	],
	"./sux-taggeldauswertung-48px.icon": [
		5316,
		5316
	],
	"./sux-technischer-support-48px.icon": [
		7653,
		7653
	],
	"./sux-themenablage-48px.icon": [
		1092,
		1092
	],
	"./sux-thumbs-up-48px.icon": [
		1958,
		1958
	],
	"./sux-tickets-48px.icon": [
		5334,
		5334
	],
	"./sux-tipp-16px.icon": [
		4729,
		4729
	],
	"./sux-tipp-24px.icon": [
		920,
		920
	],
	"./sux-todesfall-48px.icon": [
		7087,
		7087
	],
	"./sux-tram-48px.icon": [
		9563,
		9563
	],
	"./sux-transport-48px.icon": [
		7206,
		7206
	],
	"./sux-trash-16px.icon": [
		4816,
		4816
	],
	"./sux-trash-24px.icon": [
		7029,
		7029
	],
	"./sux-twitter-16px.icon": [
		299,
		299
	],
	"./sux-twitter-24px.icon": [
		1106,
		1106
	],
	"./sux-unfalldossier-48px.icon": [
		2292,
		2292
	],
	"./sux-unfallverwaltung-48px.icon": [
		5844,
		5844
	],
	"./sux-upload-16px.icon": [
		9315,
		9315
	],
	"./sux-upload-24px.icon": [
		906,
		906
	],
	"./sux-user-16px.icon": [
		3389,
		3389
	],
	"./sux-user-24px.icon": [
		1036,
		1036
	],
	"./sux-versammlung-karussel-48px.icon": [
		6883,
		6883
	],
	"./sux-versicherung-48px.icon": [
		3282,
		3282
	],
	"./sux-video-16px.icon": [
		3603,
		3603
	],
	"./sux-video-24px.icon": [
		5194,
		5194
	],
	"./sux-voraussetzung-zertifikat-48px.icon": [
		9253,
		9253
	],
	"./sux-warning-16px.icon": [
		1414,
		1414
	],
	"./sux-warning-24px.icon": [
		5211,
		5211
	],
	"./sux-web-16px.icon": [
		7116,
		7116
	],
	"./sux-web-24px.icon": [
		9745,
		2126
	],
	"./sux-wegweiser-48px.icon": [
		4087,
		4087
	],
	"./sux-whatsapp-16px.icon": [
		7774,
		7774
	],
	"./sux-whatsapp-24px.icon": [
		4707,
		4707
	],
	"./sux-word-16px.icon": [
		3016,
		3016
	],
	"./sux-word-24px.icon": [
		1405,
		1405
	],
	"./sux-work-life-balance-48px.icon": [
		8920,
		8920
	],
	"./sux-xing-16px.icon": [
		7340,
		7340
	],
	"./sux-xing-24px.icon": [
		1409,
		1409
	],
	"./sux-youtube-16px.icon": [
		9049,
		9049
	],
	"./sux-youtube-24px.icon": [
		4187,
		6568
	],
	"./sux-zahnverletzung-48px.icon": [
		8002,
		8002
	],
	"./sux-zoomin-16px.icon": [
		9688,
		9688
	],
	"./sux-zoomin-24px.icon": [
		8333,
		8333
	],
	"./sux-zoomout-16px.icon": [
		2126,
		9745
	],
	"./sux-zoomout-24px.icon": [
		3568,
		3568
	],
	"./sux-zugang-betrieb-verantwortlicher-48px.icon": [
		7485,
		7485
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2861;
module.exports = webpackAsyncContext;